import {
  createMorrowSignalAtoms,
  INITIAL_MORROW_SIGNAL_TICK,
  type MorrowSignalTick,
} from "@t3tools/client-runtime/state/morrowSignals";
import * as Option from "effect/Option";
import { AsyncResult, Atom } from "effect/unstable/reactivity";

import { connectionAtomRuntime } from "../connection/runtime";
import { activeEnvironmentIdAtom } from "./entities";

/**
 * Client wiring for the server's per-user "something changed" pokes (see
 * `MorrowSignalHub` on the server). Lets the allowance / comms panels refetch on
 * a WS push instead of polling on a fast timer.
 */
export const morrowSignalEnvironment = createMorrowSignalAtoms(connectionAtomRuntime);

/**
 * The latest signal tick for the ACTIVE environment, or the initial tick when
 * there's no active environment yet. The null-environment conditional lives
 * INSIDE this derived atom so `useMorrowSignal` can read it unconditionally
 * (React hooks can't call `useAtomValue` conditionally).
 */
export const activeMorrowSignalTickAtom = Atom.make((get): MorrowSignalTick => {
  const environmentId = get(activeEnvironmentIdAtom);
  if (!environmentId) return INITIAL_MORROW_SIGNAL_TICK;
  return Option.getOrElse(
    AsyncResult.value(get(morrowSignalEnvironment.tickAtom(environmentId))),
    () => INITIAL_MORROW_SIGNAL_TICK,
  );
});
